export default __webpack_public_path__ + "static/media/irisLogo.860eafe6.png";